/** FTR6: auto-unit formatters for the HUD. */

const AU_KM = 149_597_870.7;

/**
 * Velocity auto-unit: m/s → km/s → Mm/s → AU/s, so both fine maneuvering and
 * FLIGHT-2 supercruise (up to ~2,000,000 km/s) read sensibly.
 */
export const fmtSpeed = (kmPerSec: number): string => {
  const a = Math.abs(kmPerSec);
  if (a < 1) return `${(kmPerSec * 1000).toFixed(0)} m/s`;
  if (a < 1000) return `${kmPerSec.toFixed(2)} km/s`;
  if (a < AU_KM) return `${(kmPerSec / 1000).toFixed(1)} Mm/s`; // megametres/s
  return `${(kmPerSec / AU_KM).toFixed(3)} AU/s`;
};

/** Distance: km under 1e6, else Mkm. */
export const fmtDistance = (km: number): string => {
  if (km < 1_000_000) return `${km.toFixed(0)} km`;
  return `${(km / 1_000_000).toFixed(2)} Mkm`;
};

/** Closing speed with sign hint. */
export const fmtClosing = (kmPerSec: number): string => {
  const sign = kmPerSec >= 0 ? '+' : '';
  return `${sign}${fmtSpeed(kmPerSec)}`;
};
